import { render, staticRenderFns } from "./SearchResultRow.vue?vue&type=template&id=20dd4084&scoped=true"
import script from "./SearchResultRow.vue?vue&type=script&lang=js"
export * from "./SearchResultRow.vue?vue&type=script&lang=js"
import style0 from "./SearchResultRow.vue?vue&type=style&index=0&id=20dd4084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd4084",
  null
  
)

export default component.exports